<template>
  <TooltipProvider>
    <TooltipRoot v-bind="emitsAsProps" :open :delay-duration>
      <TooltipTrigger as-child>
        <slot />
      </TooltipTrigger>
      <TooltipPortal :to="to">
        <TooltipContent
          :align
          :side
          :side-offset
          class="text-xs text-neutral-100 bg-neutral-950 py-2 px-4 rounded-md"
        >
          <template v-if="content">
            {{ content }}
          </template>
          <slot v-else name="content" />
          <TooltipArrow :height="arrowHeight" :width="arrowWidth" />
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>

<script setup>
import {
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
  TooltipPortal,
  useEmitAsProps,
} from 'radix-vue';

defineProps({
  content: {
    type: String,
    required: false,
    default: null,
  },
  delayDuration: {
    type: Number,
    default: 0,
  },
  open: {
    type: Boolean,
    default: undefined,
  },
  align: {
    type: String,
    default: 'center',
  },
  side: {
    type: String,
    default: 'top',
  },
  sideOffset: {
    type: Number,
    default: 0,
  },
  arrowHeight: {
    type: Number,
    default: 5,
  },
  arrowWidth: {
    type: Number,
    default: 10,
  },
  to: {
    type: String,
    default: undefined,
  },
});

const emits = defineEmits(['update:open']);

const emitsAsProps = useEmitAsProps(emits);
</script>
